import "../../toggle/toggle.css";

function Toggle({ domainIndex, setIcontoolsField, lrotate }) {

    const handleChange = () => {
        if (lrotate) {
            setIcontoolsField(domainIndex, "lrotate", false);
            setIcontoolsField(domainIndex, "pole_lat", 90);
            setIcontoolsField(domainIndex, "pole_lon", -180);
        } else {
            setIcontoolsField(domainIndex, "lrotate", true);
            setIcontoolsField(domainIndex, "pole_lat", 90);
            setIcontoolsField(domainIndex, "pole_lon", -180);
        }

    };

    return (
        <div className={"toggle-wrapper domain-toggle-wrapper"}>
            <p className={"toggle-label"}>Rotated</p>
            <div className="toggle">
                <input
                    type="checkbox"
                    id={"toggle-domain-type dn" + domainIndex}
                    className="toggleCheckbox"
                    onChange={handleChange}
                    checked={lrotate}
                />
                <label htmlFor={"toggle-domain-type dn" + domainIndex} className="toggleContainer">
                    <div style={lrotate ? null : { color: "white" }}>No</div>
                    <div style={lrotate ? { color: "white" } : null}>Yes</div>
                </label>
            </div>
        </div>
    );
}

export default Toggle;
